import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Achivement.css';

const Achivement = () => {
    return (
        <section className="achivement-wrap text-white">
            <Container>
                <Row className="align-items-center">
                    <Col md={6} lg={6} sm={12}>
                        <div className="section-title">
                            <h1 className='text-white'>Our <span>Achievement</span></h1>
                        </div>
                        <div className="achivement-txt">
                            <p className="w-75">Dr. Abhinav Anand, the mind behind CurativePhysio brings joy to numerous patients through physiotherapy, renewing their physical well-being.</p>
                            <div className="action-btn">
                            <Link to="/appoinment"><button  className="theme-btn btn-fill">Appoinment</button></Link>
                            <Link to="/contact"><button  className="theme-btn btn-fill">Contact</button></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} lg={6} sm={12}>
                        <Row className="achivement-funfact text-white">
                            <Col sm={6} className="text-center">
                                <div className="single-funfact">
                                    <span>500 +</span>
                                    <p>Happy Patients</p>
                                </div>
                            </Col>
                            <Col sm={6} className="text-center">
                                <div className="single-funfact">
                                    <span>2 +</span>
                                    <p>Physiotherapist</p>
                                </div>
                            </Col>
                            <Col sm={6} className="text-center">
                                <div className="single-funfact">
                                    <span>4 +</span>
                                    <p>Govt. Certified</p>
                                </div>
                            </Col>
                            <Col sm={6} className="text-center">
                                <div className="single-funfact">
                                    <span>10 +</span>
                                    <p>Awards</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Achivement;